import { FieldTree, SchemaPath, validate } from "@angular/forms/signals";
import { S25Util } from "./s25-util";

export namespace SignalFormUtil {
    export function valueIf<T>(tree: FieldTree<T>, options: { dirty?: boolean; hidden?: boolean }): T | undefined {
        if (S25Util.isBool(options?.dirty) && options.dirty !== tree().dirty()) return undefined;
        if (S25Util.isBool(options?.hidden) && options.hidden !== tree().hidden()) return undefined;
        return tree().value();
    }

    export function minLengthValidator(path: SchemaPath<string>, min: number, options?: { message?: string }) {
        validate(path, (field) => {
            if (field.value().length < min) {
                return {
                    kind: "length",
                    message: options?.message || `Please enter ${min} characters or more`,
                };
            }
        });
    }

    export function maxLengthValidator(path: SchemaPath<string>, max: number, options?: { message?: string }) {
        validate(path, (field) => {
            if (field.value().length > max) {
                return {
                    kind: "length",
                    message: options?.message || `Please enter ${max} characters or less`,
                };
            }
        });
    }
}
